module.exports = __webpack_public_path__ + "static/media/home.e656efc6.svg";